import { render, staticRenderFns } from "./RateDryingQuality.vue?vue&type=template&id=2b3c65dc&scoped=true&"
import script from "./RateDryingQuality.vue?vue&type=script&lang=ts&"
export * from "./RateDryingQuality.vue?vue&type=script&lang=ts&"
import style0 from "./RateDryingQuality.vue?vue&type=style&index=0&id=2b3c65dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3c65dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
